module.exports = __webpack_public_path__ + "static/media/06.2b14e3a7.jpg";